var _style, _path, _path2, _path3, _g, _g2, _g3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTongueout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000091005338910985573310000006300327960786281861_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94.1 94.1",
    style: {
      enableBackground: "new 0 0 94.1 94.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E3E80;}\n\t.st1{fill:#59AC31;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,50.3c-0.7,0-1.3-0.6-1.3-1.3V20.7c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3V49C48.3,49.8,47.7,50.3,47,50.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,46c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S34,43.8,34,46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.5,46c0,2.2-1.8,4-4.1,4s-4-1.8-4-4s1.8-4,4-4S69.5,43.8,69.5,46"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-66.7-60.7L-66.7-60.7c2.7,0.5,5.6,0.8,8.5,0.8s5.7-0.3,8.4-0.8h0c3.6-0.7,6.9-1.8,9.7-3.2 c1.3-0.7,2.8,0.5,2.5,1.9c-1.2,5.3-5.2,9.7-10.6,12.2c-1.3,4.3-5.3,7.4-10,7.4s-8.7-3.1-10-7.4c-5.4-2.4-9.4-6.8-10.6-12.2 c-0.3-1.5,1.2-2.6,2.5-1.9C-73.6-62.5-70.3-61.4-66.7-60.7z M-68.8-54v-3.6c-1.8-0.4-3.6-0.9-5.2-1.5C-72.8-57.1-71-55.4-68.8-54 L-68.8-54z M-47.7-57.6v3.6c2.2-1.3,4-3.1,5.2-5C-44.2-58.5-45.9-58-47.7-57.6L-47.7-57.6z M-51.2-57c-2.3,0.3-4.6,0.5-7,0.5 s-4.7-0.2-7-0.5v4c0,3.9,3.1,7,7,7s7-3.1,7-7C-51.2-53-51.2-57-51.2-57z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-47.9-61.2c-0.6,0.2-1.3,0.3-1.9,0.4h0c-2.7,0.5-5.5,0.8-8.5,0.8s-5.7-0.3-8.5-0.8h0c-0.7-0.1-1.3-0.3-2-0.4 c0,1.1-0.1,2.7-0.1,5v0.8c0,4,0.3,5.3,0.4,5.5c0,0,0,0,0.1,0c1.3,4.3,5.3,7.4,10,7.4s8.7-3.1,10.1-7.4c0,0,0.5-1.2,0.5-6.3 C-47.8-58.5-47.8-60.1-47.9-61.2L-47.9-61.2z M-51.2-53c0,3.9-3.1,7-7,7s-7-3.1-7-7v-4c2.3,0.3,4.6,0.5,7,0.5s4.8-0.2,7-0.5V-53z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-40.2-64c-2.8,1.4-6.1,2.5-9.7,3.2h0c-2.7,0.5-5.5,0.8-8.4,0.8s-5.8-0.3-8.4-0.8c-3.6-0.7-6.9-1.8-9.7-3.2 c-1.3-0.7-2.8,0.5-2.5,1.9c1.1,5.1,6.1,4.8,4.9,2.9c1.6,0.6,5,1.4,5,1.4c0.7,0.1,1.3,0.3,2,0.4h0c0.7,0.1,1.4,0.2,2.1,0.3 c0.6,0.1,1.1,0.1,1.7,0.2c0.3,0,0.5,0.1,0.8,0.1c0.5,0.1,1,0.1,1.4,0.1c0.9,0.1,1.7,0.1,2.6,0.1c0.8,0,1.6,0,2.4-0.1 c0.6,0,1.2-0.1,1.8-0.1c0.1,0,0.3,0,0.4-0.1c0.7-0.1,1.3-0.1,1.9-0.2c0.7-0.1,1.4-0.2,2.1-0.3h0c0.7-0.1,1.3-0.3,2-0.4 c0,0,3.5-0.8,5.1-1.4c-1.2,1.9,3.8,2.2,4.9-2.9C-37.3-63.5-38.8-64.7-40.2-64L-40.2-64z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,94.1C21.1,94.1,0,73,0,47S21.1,0,47,0s47,21.1,47,47S73,94.1,47,94.1z M47,3.4C23,3.4,3.4,23,3.4,47 S23,90.7,47,90.7s43.7-19.6,43.7-43.7S71.1,3.4,47,3.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTongueout);
export default __webpack_public_path__ + "static/media/Tongue out.65f33a4ff4c4012f8f38e4379110d6c3.svg";
export { ForwardRef as ReactComponent };